// extracted by css-extract-rspack-plugin
export default {"CreateIssueContainer":"CreateIssue-module__CreateIssueContainer__GAFFfmf"};